import React, { useEffect, useRef } from "react";
import styled from "styled-components";

import Navbar from "./Navbar";
import Hero from "./Hero";
import PhotoSlider from "./PhotoSlider";
import Services from "./Services";
import Contact from "./Contact";
import Footer from "./Footer";
import Photo from "./Photo";
import Banner from "./Banner";
import { ScrollRestoration } from "react-router-dom";

const Home = () => {
  const HomeRef = useRef(null);
  const ServiceRef = useRef(null);
  const ContactRef = useRef(null);

  return (
    <Container>
      <Navbar
        HomeRef={HomeRef}
        ServiceRef={ServiceRef}
        ContactRef={ContactRef}
      />
      <Hero HomeRef={HomeRef} />

      <Services ServiceRef={ServiceRef} />
      <PhotoSlider />
      <Banner />
      <Contact ContactRef={ContactRef} />
      <Footer
        HomeRef={HomeRef}
        ServiceRef={ServiceRef}
        ContactRef={ContactRef}
      />
    </Container>
  );
};

const Container = styled.div`
  height: fit-content;
  padding-top: 105px;
  width: 100%;
  height: 100vh;
  position: relative;
  background-color: #161616;

  @media only screen and (max-width: 815px) {
    height: fit-content;
  }
`;

export default Home;
